import * as XLSX from "xlsx";

const ExcelService = {
    exportEntite(collections, collectionName) {
        let formattedName = collectionName.replace(/\s+/g, "_").replace(/[\[\]\:*?/\\]/g, "");
        if (formattedName.length > 31) formattedName = formattedName.substring(0, 31);

        const nomfichier = "Entités_collection_" + formattedName;
        const wb = XLSX.utils.book_new();

        const wsDatacollection = [[
            "ID",
            "Nom de l'entité",
            "Type",
            "NB.Fichiers",
            "ID de la collection",
            "Surface ( en m² )",
            "Surface ( en km² )",
            "Latitude",
            "Longitude",
            "Longueur ( en km )",
            "Rayon ( en km )",
            "Observation ( texte brut )",
            "Observation ( format html )"
        ]];

        collections.forEach((collection) => {
            const geojson = collection.geojson;

            const measures = this.getGeometryMeasures(geojson);

            wsDatacollection.push([
                collection.id || "",
                geojson?.properties?.titre || "",
                geojson?.properties?.type || "",
                geojson?.properties?.nb_fichier || "",
                geojson?.properties?.collection_id || "",
                measures.surfaceM2,
                measures.surfaceKm2,
                measures.latitude,
                measures.longitude,
                measures.distance,
                measures.radiusc,
                this.getPlainTextFromObservation(collection?.observation),
                collection?.observation || ""
            ]);
        });

        const wsCollections = XLSX.utils.aoa_to_sheet(wsDatacollection);
        this.autoFitColumns(wsCollections, wsDatacollection);
        XLSX.utils.book_append_sheet(wb, wsCollections, formattedName);

        XLSX.writeFile(wb, nomfichier + ".xlsx");
    },

    exportCollection(collections, type) {
        const titre = type === "collection" ? "Mes collections" : "Mes collections partagées";
        const nomfichier = type === "collection" ? "collections" : "collections_partagées";

        const wb = XLSX.utils.book_new();

        const wsDatacollection = [[
            "Identifiant",
            "Nom de la collection",
            "Nombre d'entités"
        ]];

        collections.forEach((collection) => {
            wsDatacollection.push([
                collection.id || "",
                collection.nom_affiche || "",
                collection.nb_entite || ""
            ]);
        });

        const wsCollections = XLSX.utils.aoa_to_sheet(wsDatacollection);
        this.autoFitColumns(wsCollections, wsDatacollection);
        XLSX.utils.book_append_sheet(wb, wsCollections, titre);

        collections.forEach((collection, index) => {
            const features = collection.geojson?.features || [];

            const wsData = [[
                "ID",
                "Nom de l'entité",
                "Type",
                "NB.Fichiers",
                "ID de la collection",
                "Surface ( en m² )",
                "Surface ( en km² )",
                "Latitude",
                "Longitude",
                "Longueur ( en km )",
                "Rayon ( en km )",
                "Observation ( texte brut )",
                "Observation ( format html )"
            ]];

            features.forEach((feature) => {
                const measures = this.getGeometryMeasures(feature);

                wsData.push([
                    feature.id || "",
                    feature.properties?.titre || "",
                    feature.properties?.type || "",
                    feature.properties?.nb_fichier || "",
                    feature.properties?.collection_id || "",
                    measures.surfaceM2,
                    measures.surfaceKm2,
                    measures.latitude,
                    measures.longitude,
                    measures.distance,
                    measures.radiusc,
                    this.getPlainTextFromObservation(feature.properties?.observation),
                    feature.properties?.observation || ""
                ]);
            });

            const ws = XLSX.utils.aoa_to_sheet(wsData);
            this.autoFitColumns(ws, wsData);

            let baseName = (collection.nom_affiche || collection.nom_collection || `Sheet${collection.id}`)
                .replace(/[:\\/?*\[\]]/g, "");

            baseName = baseName.substring(0, 25);

            const sheetName = `${index + 1}_${baseName}`;

            XLSX.utils.book_append_sheet(wb, ws, sheetName.substring(0, 31));
        });

        XLSX.writeFile(wb, nomfichier + ".xlsx");
    },

    getGeometryMeasures(geojson) {
        let latitude = "";
        let longitude = "";
        let distance = "";
        let radiusc = "";
        let surfaceM2 = "";
        let surfaceKm2 = "";

        if (!geojson?.geometry || !geojson?.properties) {
            return {
                latitude,
                longitude,
                distance,
                radiusc,
                surfaceM2,
                surfaceKm2
            };
        }

        const type = geojson.properties?.type;

        if (type === "marker" || type === "textMarker") {
            const [lng, lat] = geojson.geometry.coordinates;

            latitude = lat;
            longitude = lng;
        } else if (type === "polyline") {
            const coord = geojson.geometry.coordinates;
            let meters = 0;

            for (let i = 0; i < coord.length - 1; i++) {
                const [startlng, startlat] = coord[i];
                const [endlng, endlat] = coord[i + 1];

                const segment = turf.lineString([
                    [startlng, startlat],
                    [endlng, endlat]
                ]);

                meters += turf.length(segment, { units: "meters" });
            }

            distance = (meters / 1000).toFixed(4);
        } else if (type === "circle") {
            const [lngc, latc] = geojson.geometry.coordinates;

            latitude = latc;
            longitude = lngc;

            const center = [lngc, latc];
            const radius = geojson.properties?.options?.radius || 0;

            const circlePolygon = turf.circle(center, radius, {
                steps: 64,
                units: "meters"
            });

            const areaM2 = turf.area(circlePolygon);

            surfaceM2 = Math.round(areaM2);
            surfaceKm2 = (areaM2 / 1_000_000).toFixed(4);
            radiusc = (radius / 1000).toFixed(4);
        } else {
            const areaM2 = turf.area(geojson);

            surfaceM2 = Math.round(areaM2);
            surfaceKm2 = (areaM2 / 1_000_000).toFixed(4);
        }

        return {
            latitude,
            longitude,
            distance,
            radiusc,
            surfaceM2,
            surfaceKm2
        };
    },

    autoFitColumns(ws, data) {
        const colWidths = data[0].map((_, colIndex) => ({
            wch: Math.max(
                ...data.map(row => row[colIndex] ? row[colIndex].toString().length : 0)
            ) + 2
        }));

        ws["!cols"] = colWidths;
    },

    getPlainTextFromObservation(html) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html || "";
        return tempDiv.textContent || tempDiv.innerText || "";
    }
};

export default ExcelService;